const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoingTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m445.99 421.68c34.383-42.181 55.01-96.018 55.01-154.68 0-135.31-109.69-245-245-245s-245 109.69-245 245c0 58.662 20.627 112.499 55.01 154.68z",
    fill: "#ffffff",
    "data-original": "#73c3f9",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m446 42v379.68c-44.92 55.12-113.35 90.32-190 90.32-40.56 0-78.81-9.85-112.5-27.3-29.98-15.52-56.35-37.06-77.5-63.02v-379.68c0-11.05 8.95-20 20-20h340c11.05 0 20 8.95 20 20z",
    fill: "#ffffff",
    "data-original": "#deeeff",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m143.5 22v462.7c-29.98-15.52-56.35-37.06-77.5-63.02v-379.68c0-11.05 8.95-20 20-20z",
    fill: "#ffffff",
    "data-original": "#d3dcfb",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m348.5 137.5h-130c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h130c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#000e52",
    "data-original": "#bec8f7",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m406 177.5h-187.5c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h187.5c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#000e52",
    "data-original": "#bec8f7",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m163.5 187.5h-40c-9.649 0-17.5-7.851-17.5-17.5v-40c0-9.649 7.851-17.5 17.5-17.5h40c9.649 0 17.5 7.851 17.5 17.5v40c0 9.649-7.851 17.5-17.5 17.5zm-40-60c-1.378 0-2.5 1.121-2.5 2.5v40c0 1.379 1.122 2.5 2.5 2.5h40c1.378 0 2.5-1.121 2.5-2.5v-40c0-1.379-1.122-2.5-2.5-2.5z",
    fill: "#000e52",
    "data-original": "#bec8f7",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m348.5 237.5h-130c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h130c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#000e52",
    "data-original": "#bec8f7",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m406 277.5h-187.5c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h187.5c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#000e52",
    "data-original": "#bec8f7",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m163.5 287.5h-40c-9.649 0-17.5-7.851-17.5-17.5v-40c0-9.649 7.851-17.5 17.5-17.5h40c9.649 0 17.5 7.851 17.5 17.5v40c0 9.649-7.851 17.5-17.5 17.5zm-40-60c-1.378 0-2.5 1.121-2.5 2.5v40c0 1.379 1.122 2.5 2.5 2.5h40c1.378 0 2.5-1.121 2.5-2.5v-40c0-1.379-1.122-2.5-2.5-2.5z",
    fill: "#000e52",
    "data-original": "#bec8f7",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m348.5 337.5h-130c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h130c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#000e52",
    "data-original": "#bec8f7",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m406 377.5h-187.5c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h187.5c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#000e52",
    "data-original": "#bec8f7",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m163.5 387.5h-40c-9.649 0-17.5-7.851-17.5-17.5v-40c0-9.649 7.851-17.5 17.5-17.5h40c9.649 0 17.5 7.851 17.5 17.5v40c0 9.649-7.851 17.5-17.5 17.5zm-40-60c-1.378 0-2.5 1.121-2.5 2.5v40c0 1.379 1.122 2.5 2.5 2.5h40c1.378 0 2.5-1.121 2.5-2.5v-40c0-1.379-1.122-2.5-2.5-2.5z",
    fill: "#000e52",
    "data-original": "#bec8f7",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m348.5 437.5h-130c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h130c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z",
    fill: "#000e52",
    "data-original": "#bec8f7",
    style: {},
    className: ""
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m403.666 462.5h-185.166c-4.142 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5h162.902c7.705-4.6 15.137-9.608 22.264-15z",
    fill: "#000e52",
    "data-original": "#bec8f7",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m163.5 412.5h-40c-9.649 0-17.5 7.851-17.5 17.5v30.711c13.338 10.344 27.769 19.344 43.097 26.789h14.403c9.649 0 17.5-7.851 17.5-17.5v-40c0-9.649-7.851-17.5-17.5-17.5zm2.5 57.5c0 1.379-1.122 2.5-2.5 2.5h-40c-1.378 0-2.5-1.121-2.5-2.5v-40c0-1.379 1.122-2.5 2.5-2.5h40c1.378 0 2.5 1.121 2.5 2.5z",
    fill: "#000e52",
    "data-original": "#bec8f7",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m329.846 301.134 162.214-162.214c11.66-11.66 12.02-30.653.46-42.413-.156-.159-.314-.317-.473-.473-11.76-11.559-30.753-11.2-42.413.46l-162.214 162.214z",
    fill: "#ffdd40",
    "data-original": "#ffdd40",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m358.933 187.194-71.513 71.513 42.426 42.426 71.511-71.511c-11.716 11.712-30.708 11.711-42.423-.003-11.714-11.715-11.715-30.709-.001-42.425z",
    fill: "#ffc839",
    "data-original": "#ffc839",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m498.388 104.308c-3.392-5.868-8.273-10.751-14.142-14.142l-182.684 182.684 14.142 14.142z",
    fill: "#ffc839",
    "data-original": "#ffc839",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m358.935 229.619c-2.48-2.48-4.429-5.289-5.859-8.283l-51.514 51.514 14.142 14.142 51.514-51.514c-2.995-1.43-5.803-3.379-8.283-5.859z",
    fill: "#ffba44",
    "data-original": "#ffb332",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m329.846 301.134-64.316 33.23c-6.301 3.256-13.118-3.388-10.026-9.771l31.915-65.885c24.455-2.676 45.103 17.971 42.427 42.426z",
    fill: "#fbb989",
    "data-original": "#fbb989",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m265.531 334.363 29.763-15.377c-1.798-12.489-11.355-22.443-23.76-24.749l-1.215-.226-14.814 30.581c-3.092 6.384 3.724 13.027 10.026 9.771z",
    fill: "#473b4c",
    "data-original": "#6c5475",
    style: {},
    className: ""
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m143.5 0c11.046 0 20 8.954 20 20v40c0 11.046-8.954 20-20 20-11.046 0-20-8.954-20-20v-40c0-11.046 8.954-20 20-20z",
    fill: "#473b4c",
    "data-original": "#6c5475",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m143.5 40c-11.046 0-20-8.954-20-20v40c0 11.046 8.954 20 20 20 11.046 0 20-8.954 20-20v-40c0 11.046-8.954 20-20 20z",
    fill: "#4b3c50",
    "data-original": "#543e5b",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m218.5 0c11.046 0 20 8.954 20 20v40c0 11.046-8.954 20-20 20-11.046 0-20-8.954-20-20v-40c0-11.046 8.954-20 20-20z",
    fill: "#473b4c",
    "data-original": "#6c5475",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m218.5 40c-11.046 0-20-8.954-20-20v40c0 11.046 8.954 20 20 20 11.046 0 20-8.954 20-20v-40c0 11.046-8.954 20-20 20z",
    fill: "#4b3c50",
    "data-original": "#543e5b",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m293.5 0c11.046 0 20 8.954 20 20v40c0 11.046-8.954 20-20 20-11.046 0-20-8.954-20-20v-40c0-11.046 8.954-20 20-20z",
    fill: "#473b4c",
    "data-original": "#6c5475",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m368.5 0c11.046 0 20 8.954 20 20v40c0 11.046-8.954 20-20 20-11.046 0-20-8.954-20-20v-40c0-11.046 8.954-20 20-20z",
    fill: "#473b4c",
    "data-original": "#6c5475",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m148.92 167.08c-1.989 0-3.897-.79-5.303-2.196l-15-15c-2.929-2.93-2.929-7.678 0-10.607 2.929-2.928 7.678-2.928 10.606 0l9.697 9.697 29.276-29.277c2.929-2.928 7.678-2.928 10.606 0 2.929 2.93 2.929 7.678 0 10.607l-34.58 34.58c-1.405 1.406-3.312 2.196-5.302 2.196z",
    fill: "#1c005c",
    "data-original": "#ff7186",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m148.92 267.08c-1.989 0-3.897-.79-5.303-2.196l-15-15c-2.929-2.93-2.929-7.678 0-10.607 2.929-2.928 7.678-2.928 10.606 0l9.697 9.697 29.276-29.277c2.929-2.928 7.678-2.928 10.606 0 2.929 2.93 2.929 7.678 0 10.607l-34.58 34.58c-1.405 1.406-3.312 2.196-5.302 2.196z",
    fill: "#1c005c",
    "data-original": "#ff7186",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m148.92 367.08c-1.989 0-3.897-.79-5.303-2.196l-15-15c-2.929-2.93-2.929-7.678 0-10.607 2.929-2.928 7.678-2.928 10.606 0l9.697 9.697 29.276-29.277c2.929-2.928 7.678-2.928 10.606 0 2.929 2.93 2.929 7.678 0 10.607l-34.58 34.58c-1.405 1.406-3.312 2.196-5.302 2.196z",
    fill: "#1c005c",
    "data-original": "#ff7186",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m293.5 40c-11.046 0-20-8.954-20-20v40c0 11.046 8.954 20 20 20 11.046 0 20-8.954 20-20v-40c0 11.046-8.954 20-20 20z",
    fill: "#4b3c50",
    "data-original": "#543e5b",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m368.5 40c-11.046 0-20-8.954-20-20v40c0 11.046 8.954 20 20 20 11.046 0 20-8.954 20-20v-40c0 11.046-8.954 20-20 20z",
    fill: "#4b3c50",
    "data-original": "#543e5b",
    style: {},
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoingTask);
export default __webpack_public_path__ + "static/media/doing-task.d6fc184ce8d63500761f10d634529927.svg";
export { ForwardRef as ReactComponent };